var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "take-photo-wrap" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "拍摄注册照",
            visible: _vm.inVisible,
            width: "800px",
            "before-close": _vm.onCloseDialogEvent
          },
          on: {
            "update:visible": function($event) {
              _vm.inVisible = $event
            },
            opened: _vm.opened
          }
        },
        [
          _c("div", { staticClass: "content-wrap flex-row" }, [
            _c("div", { staticClass: "m-content__left flex-column" }, [
              _c("div", { staticClass: "m-content-item__title" }, [
                _vm._v("示例区域")
              ]),
              _c("div", { staticClass: "m-left__tip-text" }, [
                _c("span", { staticClass: "m-text-list-style" }),
                _vm._v(
                  "请正对摄像头，将人脸放在摄像框内，保持不动，参考“正确示例图”；"
                )
              ]),
              _c("div", { staticClass: "m-left__tip-text" }, [
                _c("span", { staticClass: "m-text-list-style" }),
                _vm._v(
                  "点击“拍照”，确认无误后，点击“确定”提交注册照，等待系统审核！"
                )
              ]),
              _c("img", {
                staticClass: "m-left__img-success",
                attrs: {
                  src: require("@/assets/img/takePhoto/img_tip_success.png")
                }
              }),
              _c(
                "div",
                { staticClass: "m-tip__img-text flex-row" },
                _vm._l(_vm.imgTipList, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "m-item flex-column" },
                    [
                      _c("img", {
                        staticClass: "m-tip__img",
                        attrs: { src: item.img }
                      }),
                      _c("div", { staticClass: "m-tip__text" }, [
                        _vm._v(_vm._s(item.label))
                      ])
                    ]
                  )
                }),
                0
              )
            ]),
            _c("div", { staticClass: "m-content__right flex-column" }, [
              _c("div", { staticClass: "m-content-item__title" }, [
                _vm._v("拍摄区域")
              ]),
              _c("div", { staticClass: "camera-zone-wrap" }, [
                _c("div", {
                  staticClass: "camera-zone",
                  attrs: { id: "camera-upload-box" }
                }),
                _c("div", {
                  staticClass: "camera-photo",
                  style: _vm.isReTake
                    ? { display: "block" }
                    : { display: "none" },
                  attrs: { id: "camera-photo" }
                })
              ]),
              _c(
                "div",
                {
                  staticClass: "m-right__camera flex-row",
                  on: { click: _vm.onTakeCamera }
                },
                [
                  _c("img", {
                    attrs: { src: require("@/assets/img/img_camera.png") }
                  }),
                  _c("div", { staticClass: "m-camera__text" }, [
                    _vm._v(_vm._s(_vm.isReTake ? "重拍" : "拍照"))
                  ])
                ]
              )
            ])
          ]),
          _c(
            "div",
            { staticClass: "button-group" },
            [
              _c(
                "el-button",
                {
                  staticClass: "cancel-button",
                  attrs: { size: "medium" },
                  on: { click: _vm.onCloseDialogEvent }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "ensure-button",
                  attrs: { size: "medium" },
                  on: { click: _vm.onClickEnsureEvent }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }